import React from 'react';
import ActiveCall from '../components/ActiveCall';
import CallList from '../components/CallList';
import Dialler from '../components/Dialler';

import { useSelector } from 'react-redux';
import { StoreState } from '../store';
import * as styles from '../styles/centerColumn.module.scss';

const CenterColumn: React.FC = () => {
  const hasActiveCall = useSelector(
    (state: StoreState) =>
      !!state.calls.find(
        (c) => c.active || (c.ringing && c.direction === 'IN'),
      ),
  );
  const callCount = useSelector((state: StoreState) => state.calls.length);
  const ongoingCalls = callCount > 0;

  const callListResponsiveClass = ongoingCalls
    ? styles.call_list_container_peek
    : styles.call_list_container_hidden;

  const callListClass = `
    ${styles.call_list_container}
    ${callListResponsiveClass}
  `;

  return (
    <React.Fragment>
      <div className={styles.dialler_container}>
        {hasActiveCall ? <ActiveCall /> : <Dialler />}
      </div>
      <div className={callListClass}>
        <CallList />
      </div>
    </React.Fragment>
  );
};

export default CenterColumn;
